import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';
import gestionErreur from '@/services/general/gestionErreur';
import venteFacesLc from './creationOpportunite/venteFacesLc';
import venteReseauxTempo from './creationOpportunite/venteReseauxTempo';
import venteReseauxLc from './creationOpportunite/venteReseauxLc';
import user from './modules/user';
import parametrage from './modules/parametrage';
import clients from './modules/clients';
import client from './modules/client';
import * as types from './mutation-type';
import panier from './creationOpportunite/panier';
import opportunites from './mesOpportunites/opportunites';
import modal from './creationOpportunite/modal';
import venteNumerique from './creationOpportunite/venteNumerique';
import venteReseauxNumerique from './creationOpportunite/venteReseauxNumerique';

Vue.use(Vuex);


export function dateTimeReviver(key, value) {
  let resultRegex;
  if (typeof value === 'string') {
    resultRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (resultRegex) {
      return new Date(value);
    }
  }
  return value;
}

let countErrorStorage = 0;

const logrocketPlugin = createPlugin(LogRocket);

const store = new Vuex.Store({
  modules: {
    venteFacesLc,
    venteReseauxTempo,
    venteReseauxLc,
    venteNumerique,
    user,
    clients,
    client,
    panier,
    parametrage,
    modal,
    opportunites,
    venteReseauxNumerique,
  },
  plugins: [createPersistedState({
    getState(key, storage) {
      try {
        const localValue = storage.getItem(key);
        let state;
        if (localValue !== 'undefined') {
          state = JSON.parse(localValue, dateTimeReviver);
        }
        return state;
      } catch (err) {
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      }

      return undefined;
    },
    setState(key, val, storage) {
      try {
        const value = JSON.stringify(val);
        storage.setItem(key, value);
        countErrorStorage = 0;
      } catch (err) {
        countErrorStorage += 1;
        if (countErrorStorage < 3) gestionErreur('Vider le panier et recommencer en ajoutant moins d’élément', err);
      }
    },
    paths: ['user', 'panier', 'parametrage.parametrages'],
  }), logrocketPlugin],
});

export default store;

export function resetState() {
  ['panier', 'clients', 'user', 'venteReseauxTempo', 'venteFacesLc', 'client', 'venteReseauxLc', 'opportunites', 'parametrage', 'modal', 'venteNumerique', 'venteReseauxNumerique'].forEach((module) => {
    store.commit(module + '/' + types.RESET_STATE);
  });
}



// WEBPACK FOOTER //
// ./src/store/store.js